/* Progressive enhancement only. Shopify owns contact submission, errors and success. */
if (!customElements.get('tb-pro-page')) {
  customElements.define('tb-pro-page', class extends HTMLElement {
    connectedCallback() {
      if (!this.onInquiry) this.onInquiry = this.handleInquiry.bind(this);
      this.addEventListener('click', this.onInquiry);
      if (this.statusFocused || !this.querySelector('[data-tb-pro-status]')) return;
      // Native contact fragment navigation can clear focus before load completes.
      if (!this.onReady) this.onReady = () => {
        this.focusFrame = requestAnimationFrame(() => {
          this.focusFrame = null;
          if (!this.isConnected || this.statusFocused) return;
          const status = this.querySelector('[data-tb-pro-status]');
          if (!status) return;
          this.statusFocused = true;
          status.focus();
        });
      };
      if (document.readyState === 'complete') this.onReady();
      else window.addEventListener('load', this.onReady, { once: true });
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onInquiry);
      window.removeEventListener('load', this.onReady);
      cancelAnimationFrame(this.focusFrame);
      this.focusFrame = null;
    }

    handleInquiry(event) {
      if (!(event.target instanceof Element)) return;
      const link = event.target.closest('[data-tb-pro-inquire]');
      if (!link || !this.contains(link) || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
      const models = this.querySelector('[name="contact[pro_models]"]');
      if (!models) return;
      const title = link.getAttribute('data-tb-pro-inquire');
      if (!title) return;
      const selected = models.value.split(';').map(value => value.trim()).filter(Boolean);
      if (!selected.includes(title)) {
        const next = [...selected, title].join('; ');
        if (models.maxLength < 0 || next.length <= models.maxLength) {
          models.value = next;
          models.dispatchEvent(new Event('input', {bubbles: true}));
        }
      }
      // Retain the real anchor navigation and the user's message; never intercept submit.
      models.focus({preventScroll: true});
    }
  });
}
